
import area from '@turf/area';
import * as L from 'leaflet';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IPolylineOptions } from '../models/IPolylineOptions';
import { MapType } from '../enums/MapType';
import { useMissionsStore } from '../stores/missionsStore';
import RenderColors from '../services/colors';
import { MultiMachinePolygonColors } from '../enums/MultiMachinePolygonColors';

@Component({ name: 'LeafletMapPolygon' })
export default class LeafletMapPolygon extends Vue {
  @Prop() map!: L.Map;
  @Prop() layer!: L.LayerGroup | L.Map;
  @Prop() polygon!: IPolylineOptions;
  @Prop() mapType!: MapType;

  mapPolygon = null as L.Polygon | null;
  missionStore = useMissionsStore();

  destroyed() {
    this.mapPolygon?.remove();
  }

  mounted() {
    this.mapPolygon = new L.Polygon(this.polygon.Location, this.polygon.Options);

    this.mapPolygon.addTo(this.map).bringToFront();
    this.updateMapAndArea();
  }

  @Watch('polygon')
  onShapeChange() {
    const newPath = this.polygon.Location;

    if (this.mapPolygon && newPath) {
      this.mapPolygon.setLatLngs(newPath);
      this.mapPolygon.setStyle(this.polygon.Options);
    }

    this.updateMapAndArea();
  }

  get isSingleMachineFieldBoundary() {
    return this.polygon.Options.color == RenderColors.Field;
  }

  get isSingleMachineWorkArea() {
    return this.polygon.Options.fillColor == RenderColors.WorkArea;
  }

  get isMultiMachineFieldBoundary() {
    return this.mapType == MapType.MultiMachine && this.polygon.Options.fillColor == MultiMachinePolygonColors.Boundary;
  }

  get isPrecisionAgFieldBoundary() {
    return this.polygon.Options.className && this.polygon.Options.className == 'precisionAg';
  }

  updateMapAndArea() {
    if (this.isSingleMachineFieldBoundary) {
      this.missionStore.setFieldAreaM2(this.findFieldArea());
    }

    if (this.isSingleMachineWorkArea) {
      this.missionStore.setWorkAreaAreaM2(this.findFieldArea());
    }

    if (this.isMultiMachineFieldBoundary || this.isSingleMachineFieldBoundary || this.isPrecisionAgFieldBoundary) {
      if (this.mapPolygon?.getLatLngs() != undefined && this.mapPolygon.getLatLngs().length != 0) {
        this.map.fitBounds(this.mapPolygon.getBounds());
      }
    }

    if (this.polygon.Options.className && this.polygon.Options.className == 'tractorArrow') {
      const position = this.mapPolygon?.getLatLngs() as L.LatLng[][];
      if (position && position.length > 0) this.map.setView(position[0][0]);
    }
  }

  findFieldArea() {
    return this.mapPolygon == undefined ? 0 : Math.round(area(this.mapPolygon.toGeoJSON()));
  }
}
